import React, { useState } from "react";
import { Button } from "reactstrap";
import LLMQuestionInput from "./LLMQuestionInput";
import "./LLMQuestionAnswerElement.scss";
import { generateJobInterviewQns } from "./jobInterviewQnsUtil";
import { getLLResponse } from "../../../../helpers/backend_helper";
import { toast } from "react-toastify";
import JobSingleQns from "./JobSingleQns";

import { DndContext } from "@dnd-kit/core";
import { SortableContext, arrayMove } from "@dnd-kit/sortable";
// Import uuidv4
import { v4 as uuidv4 } from "uuid";

const initialData = {
  interviewQuestions: [],
  prompt: "",
};

const LLMQuestionAnswerElement = ({ formStateHook, field, formik }) => {
  //llmqa
  const [isLoading, setIsLoading] = useState(false);
  const [addExistingQns, setAddExistingQns] = useState(true);

  function parseHtmlToText(htmlString) {
    // Use DOMParser to parse the HTML string
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, "text/html");

    // Extract the text content of the parsed document
    return doc.body.textContent || "";
  }

  const jsonParse = (value, initialValue) => {
    try {
      const newValue = JSON.parse(value);
      if (!newValue?.interviewQuestions) {
        return initialValue;
      }
      // return JSON.parse(JSON.stringify(newValue));
      return {
        ...newValue,
      };
    } catch (err) {
      return initialValue;
    }
  };

  const handleGetAnswer = async (prompt) => {
    if (!prompt) {
      toast.error("Please enter a valid prompt");
      return;
    }

    // Get Job Description
    const jobDescription = formik?.values?.["Jobdescription"];

    if (!jobDescription) {
      toast.error("Please enter a valid job description");
      return;
    }

    const llmRequest = generateJobInterviewQns(
      prompt,
      parseHtmlToText(jobDescription),
      3,
      true,
      {
        setExistingQns: addExistingQns,
        field: "existing_interview_questions",
        existingInterviewQns: parseInterviewQuestions(
          formik?.values?.[field?.name]
        ),
      }
    );

    try {
      setIsLoading(true);
      const response = await getLLResponse(llmRequest);
      const interviewQuestions = response?.interviewQuestions;

      // Use formik to set the value
      const newValue = jsonParse(formik?.values?.[field?.name], initialData);
      const mappedInterviewQuestions = interviewQuestions.map((question) => ({
        id: uuidv4(),
        question,
      }));
      newValue.interviewQuestions.push(...mappedInterviewQuestions);
      const newValueString = JSON.stringify(newValue);
      formik.setFieldValue(field?.name, newValueString);
    } catch (error) {
      setIsLoading(false);
      toast.error("Failed to generate questions");
    } finally {
      setIsLoading(false);
    }
  };

  const handleAddQuestion = () => {
    const newValue = jsonParse(formik?.values?.[field?.name], initialData);
    newValue.interviewQuestions.push({ id: uuidv4(), question: "" });
    const newValueString = JSON.stringify(newValue);
    formik.setFieldValue(field?.name, newValueString);
  };

  const handleDragEnd = ({ active, over }) => {
    if (!over || active.id === over.id) return;

    const currentQuestions = jsonParse(
      formik?.values?.[field?.name],
      initialData
    );

    // Find the index of the active and over items by their ids
    const oldIndex = currentQuestions.interviewQuestions.findIndex(
      (item) => item.id === active.id
    );
    const newIndex = currentQuestions.interviewQuestions.findIndex(
      (item) => item.id === over.id
    );

    // Move the item to the new index
    const newQuestions = arrayMove(
      currentQuestions.interviewQuestions,
      oldIndex,
      newIndex
    );

    // Update the questions in the formik values
    const newValue = {
      ...currentQuestions,
      interviewQuestions: newQuestions,
    };

    const newValueString = JSON.stringify(newValue);
    formik.setFieldValue(field?.name, newValueString);
  };

  const parseInterviewQuestions = (value) => {
    try {
      const interviewData = jsonParse(
        formik?.values?.[field?.name],
        initialData
      );
      if (!interviewData.interviewQuestions) {
        return [];
      }
      return interviewData.interviewQuestions;
    } catch (err) {
      return [];
    }
  };

  return (
    <div
      style={{
        width: "85%",
      }}
    >
      <LLMQuestionInput
        formik={formik}
        onGetAnswer={handleGetAnswer}
        isLoading={isLoading}
        setQuestion={(value) => {
          const newValue = jsonParse(
            formik?.values?.[field?.name],
            initialData
          );
          newValue.prompt = value;
          const newValueString = JSON.stringify(newValue);
          try {
            formik.setFieldValue(field?.name, newValueString);
          } catch (err) {}
        }}
        value={jsonParse(formik?.values?.[field?.name], initialData)?.prompt}
      />

      <div>
        <DndContext onDragEnd={handleDragEnd}>
          <SortableContext
            items={parseInterviewQuestions(formik?.values?.[field?.name]).map(
              (item) => item.id
            )}
          >
            {jsonParse(formik?.values?.[field?.name], initialData)
              .interviewQuestions &&
              jsonParse(formik?.values?.[field?.name], initialData)
                .interviewQuestions.length > 0 &&
              jsonParse(
                formik?.values?.[field?.name],
                initialData
              ).interviewQuestions.map((question, index) => (
                <div className="mt-2">
                  <JobSingleQns
                    key={question?.id}
                    question={question}
                    onChange={(e) => {
                      const newValue = jsonParse(
                        formik?.values?.[field?.name],
                        initialData
                      );
                      const newQuestions = newValue.interviewQuestions.map(
                        (q) => {
                          if (q.id === question.id) {
                            return {
                              ...q,
                              question: e.target.value,
                            };
                          }
                          return q;
                        }
                      );
                      newValue.interviewQuestions = newQuestions;
                      const newValueString = JSON.stringify(newValue);
                      formik.setFieldValue(field?.name, newValueString);
                    }}
                    onDelete={() => {
                      const newValue = jsonParse(
                        formik?.values?.[field?.name],
                        initialData
                      );
                      const newQuestions = newValue.interviewQuestions.filter(
                        (q) => q.id !== question.id
                      );
                      newValue.interviewQuestions = newQuestions;
                      const newValueString = JSON.stringify(newValue);
                      formik.setFieldValue(field?.name, newValueString);
                    }}
                  />
                </div>
              ))}
          </SortableContext>
        </DndContext>
      </div>
      <Button
        className="mt-2 w-100"
        onClick={handleAddQuestion}
        style={{
          backgroundColor: "#0A4FAE",
          color: "#fff",
        }}
      >
        + Add New
      </Button>
    </div>
  );
};

export default LLMQuestionAnswerElement;
